// extracted by mini-css-extract-plugin
module.exports = {"ThemeMain":"style_ThemeMain__Ou9tY","active":"style_active__Sb236","ThemeHead":"style_ThemeHead__KVbxC","ThemeBody":"style_ThemeBody__SvnGq","unactive":"style_unactive__BDbZV"};